var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 56 56",
    width: "56pt",
    height: "56pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_pNpHvGQ6viZRs2WGIAv0kZVOCuxayX14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_pNpHvGQ6viZRs2WGIAv0kZVOCuxayX14)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 54.929 28.635 C 54.929 26.653 54.751 24.748 54.419 22.918 L 28 22.918 L 28 33.73 L 43.097 33.73 C 42.446 37.223 40.47 40.183 37.499 42.165 L 37.499 49.178 L 46.565 49.178 C 51.869 44.312 54.929 37.147 54.929 28.635 L 54.929 28.635 Z ",
    fillRule: "evenodd",
    fill: "rgb(66,133,244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 28 55.949 C 35.574 55.949 41.924 53.446 46.565 49.178 L 37.499 42.165 C 34.987 43.842 31.774 44.833 28 44.833 C 20.694 44.833 14.51 39.916 12.304 33.31 L 2.932 33.31 L 2.932 40.552 C 7.548 49.686 17.035 55.949 28 55.949 L 28 55.949 Z ",
    fillRule: "evenodd",
    fill: "rgb(52,168,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 12.304 33.31 C 11.743 31.633 11.424 29.842 11.424 28 C 11.424 26.158 11.743 24.367 12.304 22.69 L 12.304 15.448 L 2.932 15.448 C 1.033 19.222 -0.051 23.49 -0.051 28 C -0.051 32.51 1.033 36.779 2.932 40.552 L 12.304 33.31 L 12.304 33.31 Z ",
    fillRule: "evenodd",
    fill: "rgb(251,188,5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 28 11.167 C 32.118 11.167 35.816 12.577 38.723 15.347 L 46.769 7.331 C 41.911 2.821 35.561 0.051 28 0.051 C 17.035 0.051 7.548 6.314 2.932 15.448 L 12.304 22.69 C 14.51 16.084 20.694 11.167 28 11.167 L 28 11.167 Z ",
    fillRule: "evenodd",
    fill: "rgb(234,67,53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -0.051 0.051 L 56.051 0.051 L 56.051 55.949 L -0.051 55.949 L -0.051 0.051 Z ",
    fillRule: "evenodd",
    fill: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGoogle);
export default __webpack_public_path__ + "static/media/btn_google.ea5aee663f0ffa857c7a9a9df6f555b6.svg";
export { ForwardRef as ReactComponent };